import { createFileRoute } from "@tanstack/react-router";
import { AuthForm } from "@/knowmeno/AuthGate";

export const Route = createFileRoute("/sign-up")({
  head: () => ({
    meta: [
      { title: "Create your free account — KnowMeno" },
      {
        name: "description",
        content:
          "Create your free KnowMeno account and start tracking your menopause journey today.",
      },
      { property: "og:title", content: "Create your free account — KnowMeno" },
      {
        property: "og:description",
        content:
          "Create your free KnowMeno account and start tracking your menopause journey today.",
      },
      { property: "og:url", content: "https://www.knowmeno.com/sign-up" },
    ],
    links: [{ rel: "canonical", href: "https://www.knowmeno.com/sign-up" }],
  }),
  component: SignUpPage,
});

function SignUpPage() {
  return <AuthForm mode="signup" />;
}
